"use strict";
var Observable_1 = require('../../Observable');
var distinctUntilChanged_1 = require('../../operator/distinctUntilChanged');
Observable_1.Observable.prototype.distinctUntilChanged = distinctUntilChanged_1.distinctUntilChanged;
//# sourceMappingURL=distinctUntilChanged.js.map


//////////////////
// WEBPACK FOOTER
// C:/Agent0/_work/434/s/~/rxjs/add/operator/distinctUntilChanged.js
// module id = ../../../../rxjs/add/operator/distinctUntilChanged.js
// module chunks = 3